import { Stack, XStack } from '@my/ui'
import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { SearchFiltersItem } from './search-filters-item'
import { SearchFiltersProps } from './search-filters-props'

export const SearchFilters = ({ items, selectedFilter, onFilterChange }: SearchFiltersProps) => {
  const [emblaRef] = useEmblaCarousel({
    slidesToScroll: 1,
    containScroll: 'keepSnaps',
    skipSnaps: true,
  })

  return (
    <Stack overflow="hidden" flex={1} ref={emblaRef as any}>
      <XStack gap="$2" height="auto">
        {items.map((item) => (
          <SearchFiltersItem
            key={item.name}
            {...item}
            isActive={selectedFilter === item.name}
            onPress={() => onFilterChange(item.name)}
          />
        ))}
      </XStack>
    </Stack>
  )
}
